import styled from "@emotion/styled";

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  min-height: 100%;
  background-color: white;
  display: flex;
  padding: 0px 20px 80px 20px;
  flex-direction: column;
  align-items: center;
  gap: 24px;
  align-self: stretch;
  min-width: 1060px;
  box-sizing: border-box;

  @keyframes skeleton {
    0% {
      background-color: #9299a010;
    }
    50% {
      background-color: #9299a014;
    }
    100% {
      background-color: #9299a020;
    }
  }

  .skeleton {
    animation: skeleton 2s ease-in-out 0.5s infinite;
    border-radius: 8px;
  }
`;

export const UpperSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`;

//TODO: mile-ui 라이브러리에 따로 빼내기
export const BreadCrumbs = styled.div`
  display: flex;
  padding: 12px 20px 0px 20px;
  align-items: center;
  gap: 2px;
`;

export const Heading = styled.div`
  display: flex;
  align-items: center;
  align-self: stretch;

  .title {
    display: flex;
    padding: 16px 20px;
    align-items: center;
    gap: 8px;
    flex: 1 0 0;
  }

  .btns {
    display: flex;
    padding: 8px 20px;
    justify-content: flex-end;
    align-items: center;
    gap: 8px;
  }
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;
  align-self: stretch;
`;

export const NoshowContentContainer = styled.div`
  display: flex;
  padding: 0px 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;

  .title {
    display: flex;
    padding: 0px 12px;
    align-items: center;
    gap: 4px;
    align-self: stretch;
  }

  .content-container {
    display: flex;
    padding: 20px 24px;
    flex-direction: column;
    align-items: flex-start;
    gap: 20px;
    align-self: stretch;

    border-radius: 12px;
    border: 1px solid var(--alias-color-line-strong);
    background: var(--alias-color-background-normal-alternative);

    .content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 20px;
      align-self: stretch;

      .row-section {
        display: flex;
        align-items: flex-start;
        gap: 20px;
        align-self: stretch;

        .people,
        .info {
          display: flex;
          flex-direction: column;
          align-items: flex-start;
          gap: 20px;
          flex: 1 0 0;
        }

        .divider {
          width: 1px;
          height: 100%;
          background: var(--alias-color-line-strong);
        }
      }
    }

    .history-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 8px;
      align-self: stretch;
    }
  }
`;

export const DataFiled = styled.div`
  display: flex;
  min-width: 320px;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  align-self: stretch;
`;

export const HorizontalLine = styled.div`
  height: 1px;
  width: 100%;
  background: var(--alias-color-line-strong);
`;

export const NoshowHistoryContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 20px;
  align-self: stretch;

  .line {
    height: 1px;
    width: 100%;
    background: var(--alias-color-line-normal);
  }
`;
